import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import { GUESTS_ROLES } from '../constants';

const AddRsvpFormControlComponent = ({ value, handleChange }) => (
  <FormControl>
    <RadioGroup row value={value} onChange={handleChange}>
      <FormControlLabel
        value={GUESTS_ROLES.resident}
        control={<Radio />}
        label="Resident"
      />
      <FormControlLabel
        value={GUESTS_ROLES.nonresident}
        control={<Radio />}
        label="Non-resident"
      />
      <FormControlLabel
        value={GUESTS_ROLES.staff}
        control={<Radio />}
        label="Staff"
      />
    </RadioGroup>
  </FormControl>
);

AddRsvpFormControlComponent.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default AddRsvpFormControlComponent;
